import client from './client';

/**
 * Log a user in
 * @param {string} email
 * @param {string} password
 * @returns {Promise<Object>} { token, user: { id, email, role } }
 */
export const login = async (email, password) => {
    const { data } = await client.post('/api/auth/login', { email, password });
    return data;
};

/**
 * Register a new user
 * @param {Object} userData - { firstName, lastName, email, password }
 * @returns {Promise<Object>} The new user details
 */
export const register = async (userData) => {
    const { data } = await client.post('/api/auth/register', userData);
    return data;
};

/**
 * Refresh the access token using the HTTP-only cookie
 * @returns {Promise<Object>} { token, user: { id, email, role } }
 */
export const refreshToken = async () => {
    const { data } = await client.post('/api/auth/refresh');
    return data;
};

/**
 * Logout and clear session
 * @returns {Promise<boolean>} True on success
 */
export const logout = async () => {
    await client.post('/api/auth/logout');
    return true;
};

/**
 * Get the currently authenticated user's full profile
 * @returns {Promise<Object>} User details + bookingCount
 */
export const getMe = async () => {
    const { data } = await client.get('/api/users/me');
    return data;
};

/**
 * Request a password reset email
 * @param {string} email
 * @returns {Promise<Object>} Success message
 */
export const forgotPassword = async (email) => {
    const { data } = await client.post('/api/auth/forgot-password', { email });
    return data;
};

/**
 * Reset password using a token
 * @param {string} token
 * @param {string} newPassword
 * @returns {Promise<Object>} Success message
 */
export const resetPassword = async (token, newPassword) => {
    const { data } = await client.post('/api/auth/reset-password', { token, newPassword });
    return data;
};

/**
 * Update the currently authenticated user's profile
 * @param {Object} userData - { firstName, lastName, phone }
 * @returns {Promise<Object>} Updated user details
 */
export const updateProfile = async (userData) => {
    const { data } = await client.put('/api/users/me', userData);
    return data;
};

/**
 * Change the currently authenticated user's password
 * @param {Object} passwordData - { currentPassword, newPassword, confirmPassword }
 * @returns {Promise<Object>} Success message
 */
export const updatePassword = async (passwordData) => {
    const { data } = await client.put('/api/users/me/password', passwordData);
    return data;
};
